import React, { useState, useEffect } from 'react';
import TrackingScanService from '../trackingLookup/TrackingScanService';

const SOURCE_LABELS = {
  tracking_lookup: 'สแกน Tracking JP',
  shipment_group_summary: 'สรุปกลุ่มจัดส่ง',
};

const ScanLog = () => {
  const [logs, setLogs] = useState([]);
  const [source, setSource] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    TrackingScanService.getScanLogs(200, source || null)
      .then((res) => setLogs(res.data))
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, [source]);

  return (
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-1">ประวัติการสแกน</h1>
      <p className="text-sm text-gray-500 mb-6">บันทึกทุกการสแกนบาร์โค้ดจากทุกหน้า</p>

      {/* Filter */}
      <div className="flex items-center gap-3 mb-5">
        <span className="text-sm text-gray-500">กรอง:</span>
        {['', 'tracking_lookup', 'shipment_group_summary'].map((s) => (
          <button
            key={s}
            onClick={() => setSource(s)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
              source === s
                ? 'bg-indigo-600 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {s === '' ? 'ทั้งหมด' : SOURCE_LABELS[s] || s}
          </button>
        ))}
      </div>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <div className="w-8 h-8 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
        </div>
      ) : logs.length === 0 ? (
        <div className="text-center text-gray-300 py-16 text-sm">ไม่มีข้อมูล</div>
      ) : (
        <div className="rounded-xl border border-gray-100 overflow-hidden shadow-sm">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50 text-gray-400 text-xs uppercase">
                <th className="text-left px-4 py-2 font-medium">#</th>
                <th className="text-left px-4 py-2 font-medium">หน้า</th>
                <th className="text-left px-4 py-2 font-medium">Tracking JP</th>
                <th className="text-left px-4 py-2 font-medium">Smile Name Input</th>
                <th className="text-left px-4 py-2 font-medium">Box No</th>
                <th className="text-left px-4 py-2 font-medium">ผล</th>
                <th className="text-left px-4 py-2 font-medium">เวลา</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((row, i) => (
                <tr key={row.id || i} className={`border-t border-gray-50 ${!row.found ? 'bg-red-50' : 'bg-white'}`}>
                  <td className="px-4 py-2 text-gray-400">{logs.length - i}</td>
                  <td className="px-4 py-2">
                    <span className="px-2 py-0.5 rounded text-xs bg-gray-100 text-gray-600">
                      {SOURCE_LABELS[row.source] || row.source}
                    </span>
                  </td>
                  <td className="px-4 py-2 font-mono text-gray-700">{row.trackingJp}</td>
                  <td className={`px-4 py-2 font-medium ${!row.found ? 'text-red-400' : 'text-gray-800'}`}>
                    {row.smileNameInput || '-'}
                  </td>
                  <td className="px-4 py-2 text-gray-500">{row.matchedBoxNo || '-'}</td>
                  <td className="px-4 py-2">
                    {row.found
                      ? <span className="text-green-600 font-medium">พบ</span>
                      : <span className="text-red-500 font-medium">ไม่พบ</span>
                    }
                  </td>
                  <td className="px-4 py-2 text-gray-400 whitespace-nowrap">
                    {new Date(row.createdAt).toLocaleString('th-TH')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ScanLog;
